export const columnOneHeading = "applied app template id"
export const columnTwoHeading = "display title";
export const columnThreeHeading = "assistant response";

// Location CSV import headings (AI Ordering / Dental Scheduling / AI Answering bulk import)
export const locationNameHeading = "location name";
export const storeIdHeading = "store id";
export const cloneHeading = "clone";
export const cloneFromHeading = "clone from";
export const createPhoneNumberHeading = "create phone number";
export const locationWebsiteUrlHeading = "location website url";
export const callDirectionHeading = "call direction";
